import { loadNg1Module, ngmodule } from '../../bootstrap/ngmodule'
import { umsUserWizard } from './components/wizard/wizard.component'
import { createUserConfig } from './containers/create/create.component'
import { userEditConfig } from './containers/edit/edit.component'
import { customerUsersComponent } from './containers/user-list/user-list.component'
import { customerUsersState } from './users.states'

const userModule = {
  components: { customerUsersComponent, umsUserWizard },
  states: [customerUsersState],
  configBlocks: [userEditConfig, createUserConfig],
}

loadNg1Module(ngmodule, userModule)



// WEBPACK FOOTER //
// ./app/users/users.module.js